import React, { useState, useEffect } from 'react';
import TR from './../../Trans';
import { ReactComponent as MuvikaLogoBig } from './../../assets/logo.svg';
import { ReactComponent as MuvikaLogoBigPro } from './../../assets/logo-pro.svg';
import newTracksStore from '../../stores/newTracks';
import navigationStore from '../../stores/navigation';

const bgImageTemplate = "https://player.muvika.com/graphics/images/ext-screen/ext-screen-bg-";

function OnTop(props) {

  const rollNewTracks = newTracksStore((state) => state.rollNewTracks);
  const rollExternalViewBgIndex = navigationStore((state) => state.rollExternalViewBgIndex);
  
  useEffect(() => { 
    rollNewTracks();
    rollExternalViewBgIndex();
  }, []);

  const newTracks = () => { 
    if (props.newTracksTitle) {
      let splittedTracks = props.newTracksTitle.split("#");
      let index = newTracksStore.getState().newTracksIndex;
      return splittedTracks.slice(index, index + 5).map((track, index) => 
        <h3 className="muvika-ontop-newtrack" key={index}>{track}</h3>
      );
    }
  };

  const renderCurrentPerformer = () => { 
    if(props.numSingers > 0 && props.currentTitle){
      return <h1 className="muvika-ontop-current">{props.currentTitle}</h1>
    }
  }

  const renderLogo = () => { 
    if(props.isCustomer){
      return <MuvikaLogoBig className="muvika-logo-big" />
    }else{
      return <MuvikaLogoBigPro className="muvika-logo-big" />
    }
  }

  const renderInfo = () => { 
      return <div className="fadeinout-long">
        {renderLogo()}
        {renderCurrentPerformer()}
      </div>;
  };

  return (
    <div className="muvika-on-top" style={{ width: "100%", textAlign: "center", ...props.style }}>
      {renderInfo()}
      <h2 className="muvika-ontop-latest-title">{TR.cm_latest_songs_in_catalog}:</h2>
      {newTracks()}
    </div>
  );
}

export default OnTop;